import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '../utils/metaPixel'

/**
 * Fire a Meta Pixel PageView event on every client-side route change.
 *
 * The base pixel code in index.html already fires PageView on the initial load.
 * This hook ensures subsequent React Router navigation is also tracked, but only
 * when the user has granted marketing/analytics consent.
 */
export function useMetaPixel() {
  const location = useLocation()

  useEffect(() => {
    trackPageView()
  }, [location.pathname])
}
